import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Parameters } from '@/types/parameters'
import Show from '@/components/Common/Show'
import { useTranslation } from '@/hooks/useTranslation'

interface MobileParametersDropdownProps {
  parameters: Parameters
}

const MobileParametersDropdown: React.FC<MobileParametersDropdownProps> = ({ parameters }) => {
  const { t } = useTranslation()
  const someParametersDefined = !!(parameters.methodology || parameters.context || parameters.role || parameters.goal || parameters.difficulty)
  const mainParametersDefined = !!(parameters.methodology && parameters.context && parameters.role && parameters.goal)

  return (
    <div className="space-y-3 p-3">
      <Show condition={!someParametersDefined}>
        <div className="text-sm text-gray-600 mb-1">
          <p className="font-medium">{t('parameters.welcome.header')}</p>
          <p>{t('parameters.welcome.content')}</p>
        </div>
      </Show>

      <div className="space-y-3">
        <Show condition={parameters.methodology}>
          <div className="text-sm">
            <p className="font-medium text-primary">{t('parameters.methodology.header')}</p>
            <p className="mt-1">
              <span
                dangerouslySetInnerHTML={{
                  __html: t('parameters.methodology.content', {
                    methodology: `<span class="text-[#A8CE5E] font-[Sora-Bold]">${parameters.methodology}</span>`,
                  }),
                }}
              />
            </p>
          </div>
        </Show>

        <Show condition={parameters.context}>
          <div className="text-sm">
            <p className="font-medium text-primary">{t('parameters.context.header')}</p>
            <div className="mt-1 prose prose-sm max-w-none wrap-break-word">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{parameters.context}</ReactMarkdown>
            </div>
          </div>
        </Show>

        <Show condition={parameters.role}>
          <div className="text-sm">
            <p className="font-medium text-primary">{t('parameters.roles.header')}</p>
            <p className="mt-1">
              <span className="text-[#A8CE5E] font-[Sora-Bold]">{t('parameters.roles.you')}</span> {t('parameters.roles.will_be_yourself')}
              <br />
              <span className="text-[#A8CE5E] font-[Sora-Bold]">{t('parameters.roles.roleplay_bot')}</span> {t('parameters.roles.will_be_your')}{' '}
              {parameters.role == '1' ? t('parameters.roles.superior') : parameters.role == '-1' ? t('parameters.roles.subordinate') : t('parameters.roles.unknown')}
            </p>
          </div>
        </Show>

        <Show condition={parameters.goal}>
          <div className="text-sm">
            <p className="font-medium text-primary">{t('parameters.objective.header')}</p>
            <p className="mt-1">
              <span
                dangerouslySetInnerHTML={{
                  __html: t('parameters.objective.content', {
                    goal: `<span class="text-[#A8CE5E] font-[Sora-Bold]">${parameters.goal}</span>`,
                  }),
                }}
              />
            </p>
          </div>
        </Show>

        <Show condition={mainParametersDefined && !!parameters.difficulty}>
          <div className="pt-2 border-t text-sm">
            <p className="font-medium text-primary">{t('parameters.difficulty.header')}</p>
            <p className="mt-1 text-[#A8CE5E] font-[Sora-Bold]">{t(`parameters.difficulty.options.${parameters.difficulty}`)}</p>
          </div>
        </Show>
      </div>
    </div>
  )
}

export default MobileParametersDropdown
